import { createQueryKeys } from '@lukemorales/query-key-factory'

const certificates = createQueryKeys('certificates', {
  allCertificates: {
    queryKey: null
  },
  allCertificatesCount: {
    queryKey: null
  },
  allTemplates: {
    queryKey: null
  },
  allRootTemplates: {
    queryKey: null
  },
  allTemplatesCount: {
    queryKey: null
  },
  certificateCount: (templateId?: number) => {
    return { queryKey: [templateId] }
  },
  certificateDetail: (templateId?: number, lessonId?: number) => {
    return { queryKey: [templateId, lessonId] }
  },
  customerTemplate: (templateId?: number) => {
    return { queryKey: [templateId] }
  },
  templateDetail: (templateId?: number) => {
    return { queryKey: [templateId] }
  },
  templateAvailabilityDetail: (templateId?: number, lessonId?: number) => {
    return { queryKey: [templateId, lessonId] }
  },
  downloadedCertificate: (accessHash?: string) => {
    return { queryKey: [accessHash] }
  },
  createdCertificate: (templateId?: number, lessonId?: number) => {
    return { queryKey: [templateId, lessonId] }
  }
})

export default certificates
